const offset = new Date().getTimezoneOffset()
const fill = n => n.toString().padStart(2, '0')

/**
 * @param {Number} epoch Unix timestamp in sec
 * @return {Boolean}
 */
export const isToday = epoch => {
  const d = new Date(epoch * 1000).toLocaleDateString('ja-JP')
  const t = new Date().toLocaleDateString('ja-JP')
  return d === t
}

/**
 * Unix Timestampをローカルの日付に変換する
 * @param {Number} epoch Unix timestamp in sec
 * @return {String} (mm/DD)
 */
export const epoch2date = epoch => {
  const d = epoch2obj(epoch)
  return obj2date(d)
}

/**
 * Unix Timestampをローカルの日付に変換する
 * @param {Number} epoch Unix timestamp in sec
 * @return {String} (YYYY/MM/DD)
 */
export const epoch2fullDate = (epoch, filler = '/') => {
  const d = epoch2obj(epoch)
  return obj2fullDate(d, filler)
}

/**
 * Unix Timestampをローカルの日付・時間に変換する
 * @param {Number} epoch Unix timestamp in sec
 * @return {String} (YYYY/MM/DD h:mm)
 */
export const epoch2timestamp = epoch => {
  const d = epoch2obj(epoch)
  return obj2timestamp(d)
}

/**
 * @param {String} s Date in String
 * @return {Number} Time in Epoch seconds
 */
export const string2Epoch = (s) => new Date(s).setHours(0, 0, 0, 0) / 1000

export const epoch2obj = epoch => {
  return new Date(epoch * 1000 - offset)
}

export const obj2fullDate = (d, filler = '/') => {
  const year = d.getFullYear()
  const month = d.getMonth() + 1
  const date = d.getDate()

  return year + filler + fill(month) + filler + fill(date)
}

export const obj2date = d => {
  const month = d.getMonth() + 1
  const date = d.getDate()

  return `${month}/${fill(date)}`
}

export const obj2timestamp = d => {
  const year = d.getFullYear()
  const month = d.getMonth() + 1
  const date = d.getDate()
  const hour = d.getHours()
  const minute = d.getMinutes()

  return `${year}/${fill(month)}/${fill(date)} ${hour}:${fill(minute)}`
}

/**
 * 指定日（今日から＋ーで指定）からの指定日数分のフォーマットされた日付を返す。曜日込可。
 * @param {Number} numDates 日数
 * @param {Number} startPos スタート日(「今日」から見て相対的に指定)
 * @param {Boolean} [includeWeekdays=false] 曜日も返すかどうかを指定*optional
 * @return {String[]}
 */
export const getRelativeDates = (numDates, startPos, includeWeekdays = false) => {
  const dateObjArr = getDates(numDates, startPos)
  let dates = dateObjArr.map(d => obj2date(d)) // ['month/day']

  if (includeWeekdays) {
    const weekdays = getWeekdays(dateObjArr) // ['(月)' ~ '(日)']
    dates = dates.map((date, i) => `${date} ${weekdays[i]}`)
  }
  return dates
}

const getDates = (itemNum, startPos) => {
  const today = new Date()

  return Array(itemNum).fill('').map((_, i) => {
    i === 0
      ? today.setDate(today.getDate() + startPos)
      : today.setDate(today.getDate() + 1)

    return new Date(today)
  })
}

const getWeekdays = (arr) => {
  const weekdays = new Map(
    [
      [0, '(日)'],
      [1, '(月)'],
      [2, '(火)'],
      [3, '(水)'],
      [4, '(木)'],
      [5, '(金)'],
      [6, '(土)']
    ]
  )
  return arr.map(date => weekdays.get(date.getDay()))
}
